import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';

const pspIndexesReducer = (state = initialstate.pspIndexes, action) => {
	switch (action.type) {
		case types.GET_AVAILABLE_PSP_INDEXES:
			if (action.response && !action.error) {
				const availablePSPIndexes = action.response
					?.map((item) => {
						return {
							id: item.id,
							pspIndexId: item.pspIndexID,
							displayOrder: item.displayOrder,
							isEstimate: item.isEstimate,
							value: item.pspIndexID,
							label: item.pspIndexTitle,
							knowledgeContentID: item.knowledgeContentID,
							knowledgeModifyDate: item.knowledgeModifyDate
						};
					})
					.sort((a, b) => {
						return a.displayOrder - b.displayOrder;
					});

				return availablePSPIndexes;
			}
			return state;
		default:
			return state;
	}
};

export default pspIndexesReducer;
